import React from 'react';
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.textColour,
  backgroundColor: '#fff',
  '&:hover': {
    backgroundColor: '#ccc',
  },
  boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  padding: 14,
  '&.highlighted': {
    backgroundColor: '#fffbda',
  }
}));

const DropdownContainer = styled('div')(({ theme }) => ({
  display: 'inline-block',
  [theme.breakpoints.down('sm')]: {
    marginLeft: 0
  }
}));

const DropdownContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.725),
  paddingRight: theme.spacing(3)
}));

export default function Dropdown({children, highlighted= false, title='Dropdown', buttonSize = 'normal'}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (<DropdownContainer>
    <ColorButton variant="contained"
                 color="primary"
                 className={highlighted ? 'highlighted' : ''}
                 style={{padding: buttonSize === 'small' ? '8px 12px' : 14}}
                 onClick={handleClick}
                 endIcon={<ExpandMoreIcon>expand</ExpandMoreIcon>}>
      {title}
    </ColorButton>

    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}

      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <DropdownContent>{children}</DropdownContent>
    </Popover>
  </DropdownContainer>);
}
